import { useId } from "react";

export function LanguageSelector({
  value,
  onChange,
  suggestions,
  maxLength,
  disabled,
}: {
  value: string;
  onChange: (v: string) => void;
  suggestions: string[];
  maxLength: number;
  disabled?: boolean;
}) {
  const inputId = useId();
  const listId = `${inputId}-languages`;
  const over = value.length > maxLength;

  return (
    <div className="field" style={{ gridColumn: "1 / -1" }}>
      <label htmlFor={inputId}>Response language (optional)</label>
      <input
        id={inputId}
        type="text"
        list={listId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Default (English) — type or pick a language…"
        disabled={disabled}
        autoComplete="off"
        data-testid="language-input"
      />
      <datalist id={listId} data-testid="language-suggestions">
        {suggestions.map((lang) => (
          <option key={lang} value={lang} />
        ))}
      </datalist>
      <div
        className="row"
        style={{ justifyContent: "space-between", marginTop: -2 }}
      >
        <span className="muted" style={{ fontSize: 12 }}>
          Any natural-language name works (e.g. "British English", "Kansai Japanese").
          Leave blank to use the service default.
        </span>
        <span
          style={{
            fontSize: 12,
            color: over ? "var(--negative)" : "var(--text-dim)",
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {value.length} / {maxLength}
        </span>
      </div>
    </div>
  );
}
